import React from "react";
import { Mui } from "@osu/react-ui";

const styles = {
  width100: {
    width: "100%",
  },
  listItemText: (theme) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  }),
  listItemLast: (theme) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  }),
  dataList: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    "& .MuiListItemText-root": {
      flex: "0 0 50%",
      maxWidth: "50%",
      minWidth: 0,
      margin: "0",
      boxSizing: "border-box",
    },
  },
};

const HighSchool = (props) => {
  const { studentData } = props;

  const highSchoolData = [
    {
      label: "Location",
      value: (studentData?.data?.demographics?.highSchoolLocation || ' - ').replace(/null/g, ' - '),
    },
    {
      label: "Graduation Date",
      value: studentData?.data?.demographics?.highSchoolGraduationDate || ' - ',
    },
    {
      label: "Class Standing/Size",
      value: `${studentData?.data?.demographics?.classStanding || ' - '}/${studentData?.data?.demographics?.classSize || ' - '}`,      
    },
    {
      label: "Class Rank/Type",
      value: `${studentData?.data?.demographics?.classRankPercentile || ' - '}/${studentData?.data?.demographics?.classRankType || ' - '}`,      
    },
    {
      label: "HighSchool GPA",
      value: studentData?.data?.demographics?.highSchoolGPA || ' - ',
    },
    {
      label: "CACR Score",
      value: studentData?.data?.demographics?.cacrScore || ' - ',
    },
  ];

  return (
    <>
      <Mui.Box sx={styles.width100}>
        <Mui.Typography variant="subtitle2" component="h3" sx={{ pl: 1 }}>
          {studentData?.data?.demographics?.highSchoolName}
        </Mui.Typography>
        <Mui.List
          sx={{ ...styles.width100, ...styles.dataList }}
          component="dl"
        >
          {highSchoolData.map(({ label, value }, index) => {
            return (
              <Mui.ListItemText
                key={`list=items-text-hs-${index}`}
                primary={label}
                secondary={value}
                sx={
                  index === highSchoolData.length - 1 ||
                  index === highSchoolData.length - 2
                    ? styles.listItemLast
                    : styles.listItemText
                }
                primaryTypographyProps={{
                  component: "dt",
                  className: "margin-right-2",
                  variant: "subtitle2",
                }}
                secondaryTypographyProps={{
                  component: "dd",
                  variant: "body2",
                  color: "textPrimary",
                }}
              />
            );
          })}
        </Mui.List>
      </Mui.Box>
    </>
  );
};

export default HighSchool;

